// utils/axios.js or wherever your Axios config is
import axios from "axios";
import { API_URL } from "./config";
import CryptoJS from "crypto-js";
import { ENCRYPT_KEY } from "./config";

axios.defaults.baseURL = API_URL;

axios.interceptors.request.use(
  (config) => {
    if (typeof window !== 'undefined') {
      // const lan = JSON.parse(localStorage.getItem("language"));
      const lan = localStorage.getItem("language");

      if (lan) {
        config.headers["language"] = lan; // Use your desired header key
      }
    }
    config.withCredentials = true; // apply to all requests
    return config;
  },
  (error) => Promise.reject(error)
);

// API functions
const post = async (url, data) => {
  try {
    const response = await axios.post(url, data);

    return response.data;
  } catch (err) {
    return Promise.reject(err.response?.data || err.message);
  }
};

const put = async (url, data) => {
  try {
    const response = await axios.put(url, data);
    return response.data;
  } catch (err) {
    return Promise.reject(err.response?.data || err.message);
  }
};

const get = async (url) => {
  try {
    const response = await axios.get(url);
    return response.data;
  } catch (err) {
    return Promise.reject(err.response?.data || err.message);
  }
};

const del = async (url) => {
  try {
    const response = await axios.delete(url);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

function formatDate(dateStr) {
  return new Date(dateStr).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    timeZone: "UTC",
  });
}

const formatDateMonthday = (dateStr) => {
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-US", {
    day: "2-digit",
    month: "long", // use "short" for Oct instead of October
    year: "numeric",
    timeZone: "UTC",
  });
};

function formatDateShort(dateString) {
  const date = new Date(dateString);

  const options = { day: "numeric", month: "short", year: "numeric", timeZone: "UTC" };
  return date.toLocaleDateString("en-GB", options);
}

export async function getFavicon() {
  try {
    // Fetch the data
    const res = await get('website/header-sections');
    // Get the favicon value from the response
    const favicon = res?.data?.favicon;
    const logolight = res?.data?.logolight;
    const logodark = res?.data?.logodark
    // Return the favicon
    return { favicon, logolight, logodark }
  } catch (error) {
    console.error('Error fetching favicon:', error);
    return null; // Return null or a default favicon in case of error
  }
}

export function encryptRequest(payloadObject) {
  if (!payloadObject) {
    throw new Error("No data provided for encryption.");
  }

  const laravelKey = process.env.NEXT_PUBLIC_LARAVEL_KEY;

  if (!laravelKey) {
    throw new Error("NEXT_PUBLIC_LARAVEL_KEY is not defined.");
  }

  // Decode base64 key (Laravel APP_KEY)
  const key = CryptoJS.enc.Base64.parse(laravelKey);

  // Generate random 16-byte IV
  const iv = CryptoJS.lib.WordArray.random(16);

  const plaintext = JSON.stringify(payloadObject);

  const encrypted = CryptoJS.AES.encrypt(plaintext, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  const payload = {
    iv: CryptoJS.enc.Base64.stringify(iv),
    data: CryptoJS.enc.Base64.stringify(encrypted.ciphertext),
  };

  return btoa(JSON.stringify(payload));
}




export { get, post, put, del, formatDate, formatDateMonthday, formatDateShort }; 
